import { useEffect } from "react";
import { IoMdAddCircle } from "react-icons/io";
import { MdPending } from "react-icons/md";
import { useSelector } from "react-redux";
import { LoadingSpinner } from "../components";
import AdminDataList from "../components/adminDataList";
import useDebouncedSearch from "../hooks/useDebouncedSearch";
import styles from "../styles/adminDefaultLayout.module.css";
import { AdminInstance } from "../utils/adminClass";
import { SearchAdminInstance } from "../utils/searchAdminClass";

export const AdminDefaultLayout = ({
  children,
  openForm,
  formButtonTitle,
  columns,
  actions,
  header = "Admin Default Layout",
  searchType,
  onItemSelect,
}: any) => {
  const { isLoading, products, product } = useSelector((state: any) => state.product);
  const { activeBusiness, businessType } = useSelector((state: any) => state.business);
  const searchAdmin = useSelector((state: any) => state.searchAdmin);
  const { searchInput, debouncedSearchTerm, setSearchInput } = useDebouncedSearch();

  useEffect(() => {
    SearchAdminInstance.setSearchType(searchType, setSearchInput);
    console.log("searchadminstate:", searchAdmin);
  }, []);

  useEffect(() => {
    SearchAdminInstance.setSearchType(searchType, setSearchInput);
    console.log("searchadminstate:", searchAdmin);
  }, [openForm]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      SearchAdminInstance.setSearchQuery(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm]);

  const handleSearchQueryChange = (event: any) => {
    setSearchInput(event.target.value);
  };

  const renderSearchPlaceholder = () => {
    switch (searchType) {
      case "brand":
        return "Search by brand";
      case "product":
        return "Search by product";
      case "user":
        return "Search by user";
      case "venue":
        return "Search by venue";
      case "current-customer":
        return "Search by existing customers";
      default:
        return "Search";
    }
  };

  const handleCopyUserEmailsToKeyboard = async () => {
    const emails = await AdminInstance.fetchAllUserEmails();
    console.log("COPY THESE EMAILS: ", emails);
  };

  return (
    <div className={styles.wrapper}>
      {/* HEADER AND ACTIONS */}
      <div className={styles.header}>
        <h2 onClick={handleCopyUserEmailsToKeyboard}>{header}</h2>
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          {businessType === "venue" && (
            <button>
              <MdPending />
              Pending
            </button>
          )}
          <button onClick={openForm}>
            <IoMdAddCircle />
            Add {formButtonTitle}
          </button>
        </div>
      </div>
      {/* SEARCH AND FILTER */}
      <div className={styles.searchFilterWrapper}>
        <div className={styles.search}>
          {/* TODO: TURN THIS INPUT HERE AND MENUADDPRODUCTMODAL INTO REUSABLE */}
          <input
            type="text"
            value={searchInput}
            placeholder={renderSearchPlaceholder()}
            onChange={handleSearchQueryChange}
          />
        </div>
      </div>

      {isLoading && <LoadingSpinner />}
      {/* PRODUCT LIST HEADER */}
      <div className={styles.listWrapper}>
        <AdminDataList
          items={searchAdmin.searchResults}
          //items={dateFormatted}
          columns={columns}
          actions={actions}
          onItemSelect={onItemSelect}
        />
      </div>
      {children}
    </div>
  );
};
